import { render, staticRenderFns } from "./cAddSkills.vue?vue&type=template&id=fb5297d6&scoped=true"
import script from "./cAddSkills.vue?vue&type=script&setup=true&lang=js"
export * from "./cAddSkills.vue?vue&type=script&setup=true&lang=js"
import style0 from "./cAddSkills.vue?vue&type=style&index=0&id=fb5297d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5297d6",
  null
  
)

export default component.exports